import * as React from 'react';
import { makeStyles, createStyles, Box, Divider } from '@material-ui/core';
import WhiteFlowers from '../../assets/icons/WhiteFlowers';
import { TranquiTheme } from '../../containers/App/theme';

interface DebtSeparatorWithFlowerProps {}

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  separatorBox: {
    position: 'relative',
    width: '100%',
  },
  whiteFlowers: {
    [theme.breakpoints.down(780)]: {
      display: 'none',
    },
    position: 'absolute',
    right: 0,
    bottom: 0,
    opacity: 0.3,
  },
}));

const DebtSeparatorWithFlower: React.FC<DebtSeparatorWithFlowerProps> = () => {
  const classes = useStyles();

  return (
    <Box className={classes.separatorBox}>
      <WhiteFlowers className={classes.whiteFlowers} />
      <Divider className="my-2" />
    </Box>
  );
};

export default DebtSeparatorWithFlower;
